import Ajax from '../util/ajax';
export const DIM = 'DIM';
export function dim(id, value) {
    console.log('Dim ' + id + ' level ' + value);
    return (dispatch) => {
        const a = new Ajax(dispatch);
        a.post('/transmitter/' + id + '/dim', { level: value });
        dispatch({
            type: DIM,
            id,
            value
        });
    };
}
